import { RouterProvider } from 'react-router';
import { AuthGate } from './components/AuthGate.tsx';
import { UserProvider } from './context/UserContext.tsx';
import { ToastProvider } from './context/ToastContext.tsx';
import { OnlineStatusProvider } from './context/OnlineStatusContext.tsx';
import { PwaInstallProvider } from './context/PwaInstallContext.tsx';
import { ThemeProvider } from './context/ThemeContext.tsx';
import { router } from './router.tsx';

/**
 * App root (PHASE1 §7.1, extended in Phase 3 §5.6). `ThemeProvider` sits
 * outermost (theme applies regardless of auth state) around the OIDC login
 * gate: `AuthGate` resolves the current user (or redirects to
 * `/api/auth/login`), then `UserProvider`, `ToastProvider` and the Phase-3
 * `OnlineStatusProvider` / `PwaInstallProvider` wrap the routed shell.
 */
export default function App() {
  return (
    <ThemeProvider>
      <AuthGate>
        {(user) => (
          <UserProvider user={user}>
            <ToastProvider>
              <OnlineStatusProvider>
                <PwaInstallProvider>
                  <RouterProvider router={router} />
                </PwaInstallProvider>
              </OnlineStatusProvider>
            </ToastProvider>
          </UserProvider>
        )}
      </AuthGate>
    </ThemeProvider>
  );
}
